import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { getContrastingColor } from "../../../utils/functionUltils";

const nameHeaderBlocks = t("Giới thiệu chung", "Giới thiệu chung");
const commonMedia =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M16.725 19.5q-.3-.125-.563-.263t-.537-.337l-1.075.325q-.175.05-.325-.013t-.25-.212l-.6-1q-.1-.15-.05-.325t.175-.3l.825-.725q-.05-.3-.05-.65t.05-.65l-.825-.725q-.125-.125-.175-.3t.05-.325l.6-1q.1-.15.25-.212t.325-.013l1.075.325q.275-.2.537-.337t.563-.263l.225-1.1q.05-.175.163-.288t.312-.112h1.2q.2 0 .313.113t.162.287l.225 1.1q.3.125.563.263t.537.337l1.075-.325q.175-.05.325.013t.25.212l.6 1q.1.15.05.325t-.175.3l-.825.725q.05.3.05.65t-.05.65l.825.725q.125.125.175.3t-.05.325l-.6 1q-.1.15-.25.213t-.325.012l-1.075-.325q-.275.2-.537.338t-.563.262l-.225 1.1q-.05.175-.163.288t-.312.112h-1.2q-.2 0-.313-.113t-.162-.287l-.225-1.1Zm1.3-1.5q.825 0 1.413-.588T20.025 16q0-.825-.587-1.413T18.025 14q-.825 0-1.412.588T16.024 16q0 .825.588 1.413t1.412.587ZM5 20q-.825 0-1.412-.588T3 18V4q0-.825.588-1.413T5 2h14q.825 0 1.413.588T21 4v5.65q-.475-.225-.975-.363T19 9.075V4H5v9h3.55q.3 0 .525.138t.35.362q.35.575.775.9t.925.475q-.225 1.35.063 2.675T12.275 20H5Z"/></svg>';

export const generalFooterIntroduction = (data?: any, color?: string) => {
  const blockUI = {
    id: "footer-block-id",
    label: t("Phần cuối", "Phần cuối"),
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };
  const textColor = color ? getContrastingColor(color) : "#000000";
  const logo = data?.logo;

  blockUI.content = `
    <footer id="i5d9ox" class="text-gray-600 body-font bg-gray-100"
      style="background-color: ${color || "#b40e0e"}; color: ${textColor};"
      component-class="FooterBlog">
        <div id="iy8na6" class="container px-5 py-10 mx-auto flex gap-3 md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
          <div component-class="universityLogo"><img id="i2fag" src=${logo} class="w-16"/></div>
          <div id="ijhjhp" class="w-90 flex-shrink-0 md:mx-0 mx-auto md:text-left">
          <div component-class="universityName"
          style="font-size: 18px; font-family: 'Inter-bold';"
          >${t("Đại học Bách khoa Hà Nội", "Đại học Bách khoa Hà Nội")}</div>
          <p id="ihqko5" class="mt-8">${t("Bản quyền thuộc về", "Bản quyền thuộc về")} 
            <span component-class="universityName">${t("Đại học Bách khoa Hà Nội", "Đại học Bách khoa Hà Nội")}</span>
            <p class= "mt-2">${t("Địa chỉ: Số 1 Đại Cồ Việt, Hai Bà Trưng, Hà Nội", "Địa chỉ: Số 1 Đại Cồ Việt, Hai Bà Trưng, Hà Nội")}</p>
            <p class= "mt-2">${t("Điện thoại: 024 3869 4242", "Điện thoại: 024 3869 4242")}</p>
            </p>
          </div>
          <div id="iw0yh" class="lg:w-1/4 md:w-1/2 w-full px-4">
            <nav class="list-none mb-10">
              <li id="i18zz" class="mb-2">
                <a>${t("Giới thiệu", "Giới thiệu")}</a>
              </li>
              <li id="iu5b6" class="mb-2">
                <a>${t("Khám phá", "Khám phá")}</a>
              </li>
              <li id="ivzynq" class="mb-2">
                <a>${t("Blog", "Blog")}</a>
              </li>
            </nav>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full px-4">
            <nav class="list-none mb-10">
              <li id="ik4k7l" class="mb-2">
                <a href="/clause[[QUERY_STRING]]" target="_blank" rel="noopener noreferrer">
                ${t("Chính sách", "Chính sách")}</a>
              </li>
              <li id="iw2yl9" class="mb-2">
                <a href="/clause[[QUERY_STRING]] "id="ihhfkr">${t("Quyền riêng tư", "Quyền riêng tư")}</a>
              </li>
              <li id="ipzazs" class="mb-2">
                <a id="i2jcjh">${t("Liên hệ", "Liên hệ")}</a>
              </li>
              <li id="iuvvzm">
              </li>
            </nav>
          </div>
        </div>
    </footer>`;

  return blockUI;
};

